export enum EntityType{
  TEST_CASE="TEST_CASE",
  TEST_SUITE="TEST_SUITE",
  TEST_PLAN="TEST_PLAN",
  RUN_RESULT="RUN_RESULT",
  TEST_CASE_RESULT="TEST_CASE_RESULT",
  TEST_SUITE_RESULT="TEST_SUITE_RESULT"
}
